module.exports = __webpack_public_path__ + "img/photo-13.4462e174.jpg";